export const TabNavigation = {
	links: [] as unknown as NodeListOf<HTMLAnchorElement>,
	tabs: [] as unknown as NodeListOf<HTMLElement>,

	init(): void {
		this.links = document.querySelectorAll<HTMLAnchorElement>(
			'.tab-navigation__link'
		);
		this.tabs = document.querySelectorAll<HTMLElement>(
			'.tab'
		);

		this._bindClass();
		this._bindEvents();
		this.toggleActiveTab();
		this.toggleTab();
	},

	_bindClass(): void {
		this.handleClick       = this.handleClick.bind(this);
		this.handleHashChange  = this.handleHashChange.bind(this);
		this.toggleActiveTab   = this.toggleActiveTab.bind(this);
	},

	_bindEvents(): void {
		this.links.forEach( (link: HTMLAnchorElement ): void => {
			link.addEventListener(
				'click',
				this.handleClick
			);
		} );

		window.addEventListener(
			'hashchange',
			this.handleHashChange
		);

		window.addEventListener(
			'load',
			this.handleHashChange
		);
	},

	toggleActiveTab(): void {
		const currentUrl = new URL(window.location.href);

		this.links.forEach((link) => {
			link.classList.remove(
				'tab-navigation__link--active'
			);

			const linkUrl = new URL(
				link.href,
				window.location.origin
			);

			const exactMatch =
				linkUrl.href === currentUrl.href ||
				linkUrl.href + '/' === currentUrl.href;

			const hashlessMatch =
				!linkUrl.hash &&
				linkUrl.origin === currentUrl.origin &&
				linkUrl.pathname === currentUrl.pathname;

			if ( exactMatch ) {
				link.classList.add(
					'tab-navigation__link--active'
				);
			}
		});

		if ( !document.querySelector( '.tab-navigation__link--active' ) ) {
			document.querySelector( '.tab-navigation__link' )?.classList.add( 'tab-navigation__link--active' );
		}
	},

	handleClick(event: Event): void {
		const link = event.currentTarget as HTMLAnchorElement;

		const currentUrl = new URL(window.location.href);

		const linkUrl = new URL(
			link.href,
			window.location.origin
		);

		const samePage =
			linkUrl.origin === currentUrl.origin &&
			linkUrl.pathname === currentUrl.pathname;

		if (samePage) {
			event.preventDefault();

			history.pushState(
				null,
				'',
				linkUrl.pathname +
				linkUrl.search +
				linkUrl.hash
			);

			this.toggleActiveTab();
			this.toggleTab();
		}
	},

	handleHashChange(): void {
		this.toggleActiveTab();
		this.toggleTab();
	},

	toggleTab(): void {
		const anchor = window.location.hash.split('#')[1];

		this.tabs.forEach( (tab: HTMLElement) => {
			if ( anchor === undefined && tab.dataset.tabInitial !== undefined ) {
				tab.style.display = 'block';
			}
			else {
				if ( tab.dataset.tab === anchor ) {
					tab.style.display = 'block';
				}
				else {
					tab.style.display = 'none';
				}
			}
		} )
	}
};
